import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast, ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BgImage from "../assets/lgbg.jpg";
import hrLogo1 from "../assets/hrlogo2.png";

const CreateCandidateAccount = () => {
  const [hrUsername, setHrUsername] = useState("");

  useEffect(() => {
    const hrUser = document.cookie
      .split(";")
      .find((cookie) => cookie.trim().startsWith("userName="))
      ?.split("=")[1];
    if (hrUser) setHrUsername(hrUser);
  }, []);

  const schema = yup.object().shape({
    username: yup
      .string()
      .required("Full Name is required")
      .matches(/^[a-zA-Z ]+$/, "Only letters are allowed for Name")
      .min(1, "Name must be at least 1 character")
      .max(50, "Name must be at most 50 characters"),

    email: yup
      .string()
      .required("Email is required")
      .email("Email must be valid")
      .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, "Only lowercase email addresses are allowed"),

    password: yup
      .string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),

    dob: yup.string().required("DOB is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const payload = { ...data, hrUsername };

    try {
      const response = await fetch(
        "http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/CreateCandidateAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        toast.success("Candidate account created successfully", {
          position: "top-center",
          transition: Slide,
        });
        reset();
      } else {
        toast.error(responseData?.error || "An error occurred");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to submit form. Please try again later.");
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-cover bg-center relative bg-white overflow-hidden">
        <img src={BgImage} alt="Background" className="absolute inset-0" />
        {/* <img src={hrLogo1} className="absolute top-5" /> */}
        {/* <img src={hrLogo1} className=" sm:absolute top-5 md:absolute top-5 lg: mt-32 text-2xl absolute   " /> */}

        {/* <img
  src={hrLogo1}
  className="absolute top-5 w-10 sm:w-12 md:w-14 lg:w-0 lg:mt-32 lg:text-2xl"
/> */}

        <div className="p-8 max-w-md w-full h-auto relative z-10 overflow-auto mt-2">
          <h2 className="text-lg font-bold mb-8 text-center text-white">
            Create Candidate Account   
          </h2>
          <form onSubmit={handleSubmit(onSubmit)} className="">
            <div className="mb-1">
              <label className="block text-white mb-2 text-sm">Candidate Username (As per Aadhar Card)</label>
              <input
                type="text"
                {...register("username")}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.username && <p className="text-red-500 text-sm mt-1">{errors.username.message}</p>}
            </div>

            <div className="mb-1">
              <label className="block text-white mb-2 text-sm">Email</label>
              <input
                type="email"
                {...register("email")}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
            </div>

            <div className="mb-1">
              <label className="block text-white mb-2 text-sm">DOB</label>
              <input
                type="date"
                {...register("dob")}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.dob && <p className="text-red-500 text-sm mt-1">{errors.dob.message}</p>}
            </div>

            <div className="mb-1">
              <label className="block text-white mb-2 text-sm">Password</label>
              <input
                type="password"
                {...register("password")}
                className="w-full px-2 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>}
            </div>

            <button
              type="submit"
              className="w-full bg-primary text-white py-2 rounded-lg mt-3 hover:bg-primary-dark transition duration-300"
            >
              Continue
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default CreateCandidateAccount;
